// extracted by mini-css-extract-plugin
export const container = "Footer-module--container--1RDYA";
export const footer = "Footer-module--footer--VRb5f";
export const copyright = "Footer-module--copyright--SikQz";
export const linkContainer = "Footer-module--linkContainer--3v_Ra";
export const link = "Footer-module--link--3kRZy";